"use client";

import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const SHARED_DATA = {
  address: "STL Headquarters",
  phone: "(314) 892-7800",
  email: "amichael@wt-solutions.com",
  businessName: "WTS",
  location: "Your Business Environment"
};
export default function ConnectWithUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="3332" id="partner-with-wts" className="relative w-full dark bg-background text-foreground py-24 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(var(--primary)_1px,transparent_1px)] [background-size:24px_24px] opacity-5 pointer-events-none" />
      
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          <div className="flex flex-col space-y-10">
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-sans font-bold tracking-tighter text-foreground uppercase">
                Let's engineer <br />
                <span className="text-primary">YOUR SOLUTION.</span>
              </h2>
              <p className="text-lg text-muted-foreground max-w-md leading-relaxed font-sans">
                As your turnkey AV provider, WTS specializes in delivering fully integrated systems tailored to your unique architectural and business requirements.
              </p>
            </div>

            <div className="space-y-8">
              {[{
              icon: Mail,
              label: "Inquiry Channel",
              value: SHARED_DATA.email,
              href: `mailto:${SHARED_DATA.email}`,
              action: "Send Specs"
            }, {
              icon: Phone,
              label: "Direct Line",
              value: SHARED_DATA.phone,
              href: `tel:${SHARED_DATA.phone.replace(/\D/g, '')}`,
              action: "Connect Now"
            }, {
              icon: MapPin,
              label: "Global Delivery",
              value: SHARED_DATA.address,
              href: "https://www.google.com/maps/search/?api=1&query=4667+Green+Park+Rd.+St.+Louis,+MO+63123",
              action: "View Coverage"
            }].map((item, i) => <div key={i} data-index={i} className="group flex items-start gap-6 p-6 rounded-sm border border-border/50 hover:border-primary/50 hover:bg-secondary/50 transition-all duration-300">
                  {i === 0 || i === 1 ? <Link to={item.href} className="shrink-0">
                      <div className="flex items-center justify-center size-12 rounded-sm text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300 !bg-[hsl(0,95%,41%)]">
                        <item.icon className="size-5" />
                      </div>
                    </Link> : <Link to={item.href} newTab className="shrink-0">
                      <div className="flex items-center justify-center size-12 rounded-sm text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300 !bg-[hsl(0,95%,41%)]">
                        <item.icon className="size-5" />
                      </div>
                    </Link>}
                  <div className="space-y-1">
                    <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">{item.label}</p>
                    <p className="text-lg font-semibold text-foreground">{item.value}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-4 bg-primary/5 rounded-sm blur-3xl opacity-30 pointer-events-none" />
            <div className="relative bg-card/80 backdrop-blur-md border border-border rounded-sm p-8 md:p-10 shadow-2xl">
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-foreground uppercase tracking-tight">Project Specification</h3>
                <p className="text-muted-foreground mt-2 font-sans">
                  Submit your facility requirements and our design team will provide an integrated AV proposal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}